import { useState } from 'react';
import { useMapEvents } from 'react-leaflet';
import { formatMGRS } from '../../lib/mgrs';

// MGRS + lat/long readout of the current map centre (docs/14 §6).
export default function MgrsReadout() {
  const [c, setC] = useState<{ lat: number; lon: number } | null>(null);

  const map = useMapEvents({
    moveend: () => {
      const ctr = map.getCenter();
      setC({ lat: ctr.lat, lon: ctr.lng });
    },
  });

  // initialise once
  if (!c) {
    const ctr = map.getCenter();
    if (ctr) setTimeout(() => setC({ lat: ctr.lat, lon: ctr.lng }), 0);
  }

  return (
    <div className="leaflet-bottom leaflet-left" style={{ pointerEvents: 'none' }}>
      {/* Lifted above the mobile chip bar; normal margin on desktop. The ! beats
          leaflet's own `.leaflet-bottom .leaflet-control` margin rule. */}
      <div className="leaflet-control m-2 !mb-[4.25rem] lg:!mb-[10px] px-2 py-1 rounded bg-command-bg/90 border border-command-border font-tactical text-[10px] text-gray-300">
        <div>MGRS {c ? formatMGRS(c.lat, c.lon) : '—'}</div>
        <div className="text-gray-500">{c ? `${c.lat.toFixed(5)}, ${c.lon.toFixed(5)}` : ''}</div>
      </div>
    </div>
  );
}
